// store/global.js
export const state = () => ({
  isListening: true,
  isSecondPage: false,
  bgColor:'#eeede9',
  latestNews:{},
});

export const mutations = {
  setIsListening(state, value) {
    state.isListening = value;
  },
  setSecondPage(state, value) {
    state.isSecondPage = value;
  },
  setBgColor(state, value) {
    state.bgColor = value;
  },
  setNews(state, value){
	  console.log(value)
	  state.latestNews = value;
  }
};
